import type { PropsWithChildren, ReactElement } from "react";
import { Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";
export default function SuspenseContainer({
  children,
  fallback = <DefaultFallback />,
}: PropsWithChildren<{ fallback?: ReactElement }>) {
  return <Suspense fallback={fallback}>{children}</Suspense>;
}

function DefaultFallback() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
